import type { ReactElement } from 'react'

import type { TypeSectionContentItems } from '@contentful-types/section'
import type { TypeSectionSingleColumnEntry } from '@contentful-types/section-single-column'

import { CtaDescriptionPosition, CtaDescriptionWidth } from '@constants/enums/cta'

import { AlignmentContext, DefaultAlignment } from '../../../contexts/alignment-context'
import {
  CtaButtonMetadataProvider,
  DefaultCtaButtonContext,
} from '../../../contexts/cta-button-context'
import { SingleColumnLayout } from '../../layout/single-column/single-column'
import { PageSection } from '../../page-core/section/page-section'
import { ContentRenderer } from '../../renderer'

function SingleColumnSectionContent(data: TypeSectionSingleColumnEntry): ReactElement {
  const {
    fields: { content, alignment },
  } = data

  return (
    <AlignmentContext.Provider value={alignment?.fields ?? DefaultAlignment}>
      <CtaButtonMetadataProvider
        value={{
          ...DefaultCtaButtonContext,
          descriptionWidth: CtaDescriptionWidth.Auto,
          descriptionPosition: CtaDescriptionPosition.Center,
        }}
      >
        <SingleColumnLayout>
          <ContentRenderer data={content as TypeSectionContentItems[] | undefined} />
        </SingleColumnLayout>
      </CtaButtonMetadataProvider>
    </AlignmentContext.Provider>
  )
}

export function SingleColumnSection({
  data,
}: {
  data: TypeSectionSingleColumnEntry
}): ReactElement {
  const {
    sys,
    fields: { internalName, background, heading, alignment, backgroundAssetType },
  } = data

  return (
    <PageSection
      internalName={internalName}
      sysStructure={sys}
      alignment={alignment}
      heading={heading}
      background={background}
      backgroundAssetType={backgroundAssetType}
    >
      <SingleColumnSectionContent {...data} />
    </PageSection>
  )
}

export function SingleColumnSectionForTabs(): string {
  return 'PLACEHOLDER: single column section for tabs'
}
